import React, {useEffect} from "react";
import ReactDOM from "react-dom";
import {useTranslation} from "react-i18next";
import {withFormik} from "formik";

import withTabs from "../conteiners/tabs/Tabs.hoc";
import {useTabsContext} from "../conteiners/tabs/useTabs";

import {Modal} from "./ModalProvider";
const ModalRow = ({tabs = [], modalContent, ...props}) => {
  const {t} = useTranslation();

  const {setTabs} = useTabsContext();

  useEffect(() => {
    setTabs(prev => [
      {...prev[0], title: props.label, ...props},
      ...(tabs?.map(({TabComponent, title, ...props}, index) => ({
        index: index + 1,
        TabComponent,
        title: t(title),
        ...props,
      })) ?? []),
    ]);
  }, []);

  return React.cloneElement(modalContent, {...props});
};

const ModalWithTabsNew = props => {
  const ModalWithTabsRow = withTabs({
    isClosableTabs: props.closable,
    containerStyle: {marginTop: "0.75em", paddingBottom: "5px", flexGrow: "1"},
    label: props.label,
  })(
    ModalRow,
    // withFormik({enableReinitialize: true, mapPropsToValues: () => ({})})(ModalRow)
  );

  return ReactDOM.createPortal(
    <Modal
      {...props}
      style={{border: 0}}
      modalInnerWrapperClassName="p0 aistr fcCol h100"
      noLabel
      closeBtnStyle={{top: "0.3em", zIndex: 10}}
      className="tabModal"
    >
      <ModalWithTabsRow {...props} />
    </Modal>,
    document.getElementById("modal-root"),
  );
};

export default ModalWithTabsNew;
